import tippy from 'tippy.js';

const buttons = document.querySelectorAll('.e-tooltip-btn');

Array.from(buttons).forEach((button) => {
	tippy(button, {
		content: button.getAttribute('data-tippy'),
		theme: 'light-border',
		trigger: 'click',
		offset: [0, 18],
	});
});
